import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export const ANALYSIS_IN_PROGRESS_ERROR = 'analysisInProgress';

export function hasAnalysisInProgress(control: AbstractControl | null | undefined): boolean {
  if (!control) {
    return false;
  }

  if (control.hasError(ANALYSIS_IN_PROGRESS_ERROR)) {
    return true;
  }

  if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
    return Object.values(control.controls).some(child => hasAnalysisInProgress(child));
  }

  return false;
}
